// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"0287c90a","453":"ddcd6946"}[chunkId] + ".chunk.js";
};